import React from 'react';
import { motion } from 'framer-motion';
import { FiChevronRight } from 'react-icons/fi';

const Schedules = () => {
    const courses = [
        { grade: 'A/L Combined Maths', title: 'Advanced Calculus & Limits', time: 'Mon - 4.00 PM', desc: 'Deep dive into differentiation, integration, and their practical engineering applications.' },
        { grade: 'A/L Pure Maths', title: 'Complex Numbers & Vectors', time: 'Wed - 8.30 AM', desc: 'Mastering the geometry of complex planes and spatial vector analysis.' },
        { grade: 'A/L Applied Maths', title: 'Relative Motion & Statics', time: 'Thu - 5.00 PM', desc: 'Applying Newtonian logic to complex mechanical systems and equilibrium.' },
        { grade: 'Grade 11 Maths', title: 'Probability & Statistics', time: 'Sat - 9.00 AM', desc: 'From basic set theory to complex distribution analysis for exam mastery.' },
        { grade: 'Grade 10 Maths', title: 'Geometry & Measurements', time: 'Sun - 10.30 AM', desc: 'Building foundational concepts in Euclidian geometry and advanced measurement techniques.' }
    ];

    return (
        <section className="py-24 px-6 max-w-7xl mx-auto space-y-16 bg-[#0a0a0a]">
            <div className="flex flex-col lg:flex-row justify-between items-end mb-16 gap-8">
                <div className="max-w-2xl">
                    <motion.div
                        initial={{ opacity: 0, x: -10 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        className="flex items-center gap-4 mb-4"
                    >
                        <div className="h-[2px] w-8 bg-blue-500"></div>
                        <span className="text-blue-500 font-bold uppercase tracking-widest text-xs">Academic Calendar</span>
                    </motion.div>
                    <h2 className="text-3xl md:text-5xl font-black tracking-tight text-white leading-tight">
                        JOIN THE <span className="text-blue-500">NEXT SESSION</span>
                    </h2>
                </div>
                <button className="hidden lg:flex items-center gap-2 text-white/30 font-bold text-xs tracking-widest hover:text-blue-500 transition-colors">
                    FULL CURRICULUM <FiChevronRight />
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6">
                {courses.map((c, i) => (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: i * 0.1 }}
                        viewport={{ once: true }}
                        className="bg-white/[0.03] backdrop-blur-xl rounded-[2.5rem] p-10 flex flex-col items-center text-center border border-white/5 hover:border-blue-500/30 transition-all duration-500 group"
                    >
                        {/* Logo Container */}
                        <div className="w-24 h-24 bg-white/[0.05] rounded-3xl mb-8 flex items-center justify-center p-4 border border-white/5 group-hover:scale-105 transition-transform duration-500">
                            <img
                                src={`https://ui-avatars.com/api/?name=${c.grade}&background=random&color=fff&size=200`}
                                alt={c.grade}
                                className="w-full h-full object-contain rounded-xl opacity-80 group-hover:opacity-100 transition-opacity"
                            />
                        </div>

                        <div className="space-y-4 mb-10 flex-1">
                            <div>
                                <h3 className="text-xl font-black text-white leading-tight">
                                    {c.grade.split(' ').slice(0, 2).join(' ')}
                                </h3>
                                <p className="text-lg font-bold text-white/90">
                                    {c.grade.split(' ').slice(2).join(' ') || 'Center'}
                                </p>
                            </div>
                            <p className="text-white/40 text-sm font-medium leading-relaxed max-w-[180px] mx-auto">
                                Academic year schedules and timetables
                            </p>
                        </div>

                        <button className="w-full py-4 px-6 bg-blue-500/10 text-blue-400 rounded-2xl font-black text-xs tracking-wide flex items-center justify-center gap-2 hover:bg-blue-600 hover:text-white transition-all duration-300 border border-blue-500/20">
                            View Schedule <FiChevronRight className="text-lg" />
                        </button>
                    </motion.div>
                ))}
            </div>

            {/* Need Help Banner */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                className="mt-20 p-12 bg-white/[0.02] border border-white/5 rounded-[3rem] text-center space-y-8 relative overflow-hidden group"
            >
                {/* HUD Accent */}
                <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-white/10 rounded-tl-[3rem] group-hover:border-blue-500/30 transition-colors"></div>

                <div className="space-y-2 relative z-10">
                    <h3 className="text-2xl md:text-3xl font-black text-white">Need Help with Scheduling?</h3>
                    <p className="text-white/40 font-medium">Future academic year planning and schedules</p>
                </div>
                <button className="px-10 py-5 bg-blue-600 text-white rounded-2xl font-black text-xs tracking-widest shadow-[0_15px_30px_-5px_rgba(37,99,235,0.3)] hover:bg-blue-700 hover:-translate-y-1 transition-all duration-300 relative z-10">
                    Contact Academic Support
                </button>
            </motion.div>
        </section>
    );
};

export default Schedules;
